<template>
  <div class="p-delete-account-confirmation">
    <loading v-if="isDeleteAccountConfirmationStatusFetching" />
    <delete-account-confirmation v-else />
  </div>
</template>

<script>
import { mapGetters, mapActions } from 'vuex';
import DeleteAccountConfirmation from '@/app/components/delete-account/DeleteAccountConfirmation.vue';
import Loading from '@/app/components/Loading';
import { DeleteAccountConfirmationStatus } from '../services/DeleteAccountService';

export default {
  name: 'DeleteAccountConfirmationView',
  components: {
    Loading,
    DeleteAccountConfirmation
  },
  computed: {
    ...mapGetters('app', [
      'isDeleteAccountConfirmationStatusFetching',
      'deleteAccountConfirmationStatus'
    ])
  },
  async created() {
    this.confirmAccountDeletion(this.extractQueryParams()).finally(() => {
      if (this.deleteAccountConfirmationStatus === DeleteAccountConfirmationStatus.expired) {
        this.fetchCustomerType();
      }
    });
  },
  methods: {
    ...mapActions('app', [
      'confirmAccountDeletion',
      'fetchCustomerType'
    ]),
    extractQueryParams() {
      const urlParams = new URLSearchParams(window.location.search);
      const token = urlParams.get('token');
      const tenantId = urlParams.get('tenantId');
      return { token, tenantId };
    }
  }
};
</script>

<style lang="scss" scoped>
@import '@uikit/ui-kit/themes/acronis/src/common/variables';

.p-delete-account-confirmation {
  display: flex;
  height: 100%;
  background-color: $av-solid-brand-lightest;
  &__card {
    max-width: 512px;
    margin: auto;
  }
  .p-loading {
    margin: auto;
  }
}
</style>
